import React from 'react';
import { Card, CardBody, Table, Row, Col } from 'reactstrap';

export default props => {
  const { entity } = props;
  return (
    <Card className={'h-100 card-form'}>
      <CardBody>
        <div className={'font-md color-blue'}>
          <span className={'text-capitalize'}>{'Contact Information'}</span>
          <button onClick={props.toggle}>Edit</button>
        </div>
        <Row className={'pt-2'}>
          <Col className={'content'}>
            <Table size={'sm'} borderless>
              <tbody>
                <tr>
                  <th style={{ width: '35%' }}>Requestor Role</th>
                  <td>{entity.requestor_role.name}</td>
                </tr>
                <tr>
                  <th className={'w-25'}>Requestor</th>
                  <td>
                    {entity.requestor_first_name} {entity.requestor_last_name}
                  </td>
                </tr>
                <tr>
                  <th className={'w-25'}>Requestor Email</th>
                  <td>{entity.requestors_email}</td>
                </tr>
                <tr>
                  <th className={'w-25'}>Requestor Phone</th>
                  <td>{entity.requestors_phone}</td>
                </tr>
                <tr>
                  <th className={'w-25'}>Requestor Company</th>
                  <td>{entity.requestors_company_name}</td>
                </tr>
              </tbody>
            </Table>
          </Col>
          <Col className={'content'}>
            <Table size={'sm'} borderless>
              <tbody>
                <tr>
                  <th className={'w-25'}>Borrower Email</th>
                  <td>{entity.borrowers_email}</td>
                </tr>
                <tr>
                  <th className={'w-25'}>Board Member</th>
                  <td>{entity.board_member === 0 ? 'No' : 'Yes'}</td>
                </tr>
              </tbody>
            </Table>
          </Col>
        </Row>
      </CardBody>
    </Card>
  );
};
